import styled from 'styled-components'

export const ButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px;
`